// | ------------------------------------------------------------------------
// | Ellipsis
// | ------------------------------------------------------------------------ 


//? https://github.com/yowainwright/shav
import shave from 'shave'; 


// | ------------------------------------------------------------------------


document.addEventListener( 'DOMContentLoaded', function() {

    // argument structure - shave("selector", maxheight, { options });
    shave(".ellipsis", 84, { character: "..." }); 

});